
import translator from "../utilities/translator";
import ExamStatusEnum from "./ExamStatusEnum";

export const examStatusToString = (currentLanguage, exam) => {
    var str = '';
    switch(exam?.status){
        case ExamStatusEnum.PLANNED:
            str = translator(currentLanguage, 'exam_status_planned')
            break;
        case ExamStatusEnum.STARTED:
            str = translator(currentLanguage, 'exam_status_ongoing')
            break;
        case ExamStatusEnum.REPORT:
            str = translator(currentLanguage, 'exam_status_complete')
            break;
        case ExamStatusEnum.TRANSCRIPTION:
            str = translator(currentLanguage, 'exam_status_transcribe')
            break;
        case ExamStatusEnum.TO_SIGN:
            str = translator(currentLanguage, 'exam_status_tosign')
            break;
        case ExamStatusEnum.SIGNED:
            str = translator(currentLanguage, 'exam_status_signed')
            break;
    }
    return str;
};